/**
 * @generated SignedSource<<e047d7e0f3102261d9ba8637f537435b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateExchangeRateInput = {
  currency?: string | null;
  rate?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateExchangeRateMutation$variables = {
  input: CreateExchangeRateInput;
};
export type CreateExchangeRateMutation$data = {
  readonly createExchangeRate: {
    readonly exchangeRate: {
      readonly node: {
        readonly id: string;
        readonly currency: string | null;
        readonly rate: number | null;
        readonly startDate: string | null;
        readonly endDate: string | null;
        readonly isUsed: boolean | null;
        readonly createdAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateExchangeRateMutation$rawResponse = {
  readonly createExchangeRate: {
    readonly exchangeRate: {
      readonly node: {
        readonly id: string;
        readonly currency: string | null;
        readonly rate: number | null;
        readonly startDate: string | null;
        readonly endDate: string | null;
        readonly isUsed: boolean | null;
        readonly createdAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateExchangeRateMutation = {
  variables: CreateExchangeRateMutation$variables;
  response: CreateExchangeRateMutation$data;
  rawResponse: CreateExchangeRateMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExchangeRatePayload",
    "kind": "LinkedField",
    "name": "createExchangeRate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExchangeRateTypeEdge",
        "kind": "LinkedField",
        "name": "exchangeRate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExchangeRate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateExchangeRateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateExchangeRateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a1559f5c5c6e7480e5a6076d5bf798e",
    "id": null,
    "metadata": {},
    "name": "CreateExchangeRateMutation",
    "operationKind": "mutation",
    "text": "mutation CreateExchangeRateMutation(\n  $input: CreateExchangeRateInput!\n) {\n  createExchangeRate(input: $input) {\n    exchangeRate {\n      node {\n        id\n        currency\n        rate\n        startDate\n        endDate\n        isUsed\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bdb3a76b9cbc790fc3ce25efb1d5c11d";

export default node;
